exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".lessMargin-3b802b4d{margin:0 0 20px 0}.successMessage-2f605320{text-align:center}\n", ""]);

// Exports
exports.locals = {
	"lessMargin": "lessMargin-3b802b4d",
	"successMessage": "successMessage-2f605320"
};